import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { Button, Modal, Spin, Table, Upload } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import sortBy from 'lodash/sortBy'

import { estimateSelector, getEstimateByIdAction } from '../../../store/estimate'
import { getProjectsAction, projectSelector, clearState } from '../../../store/projects'
import AddEstimateModal from '../../estimate/AddEstimateModal'
import { APP_STATUS_DONE } from '../../reports/constants'

const API_URL = process.env.REACT_APP_API_URL

const ProjectsTable = ({ onEstimateClick }) => {
  const dispatch = useDispatch()
  const { isFetching, projects, pagination } = useSelector(projectSelector)
  const { isFetching: isEstimateFetching, estimate } = useSelector(estimateSelector)
  const [selectedEstimate, setSelectedEstimate] = useState(null)
  const [selectedProject, setSelectedProject] = useState(null)
  const [showEstimateModal, setShowEstimateModal] = useState(false)
  const [page, setPage] = useState(1)
  const [fileList, setFileList] = useState([])
  const [showFileList, setShowFileList] = useState(false)

  const tablePagination = useMemo(
    () => ({
      current: page,
      pageSize: 20,
      total: pagination.total,
      onChange: setPage,
      showSizeChanger: false,
    }),
    [pagination, page]
  )

  useEffect(() => {
    dispatch(getProjectsAction({ pagination: { page, pageSize: 20 } }))
    return () => {
      dispatch(clearState())
    }
  }, [page])

  useEffect(() => {
    if (selectedEstimate === estimate?.id && !isEstimateFetching) {
      const estimateFilesList = []
      if (estimate.estimate_file_updates && estimate.estimate_file_updates.length > 0) {
        estimateFilesList.push(
          ...estimate.estimate_file_updates.map((file) => ({
            uid: file.id,
            name: file?.file?.name,
            status: APP_STATUS_DONE,
            url: `${API_URL}${file?.file?.url}`,
          }))
        )
      }
      if (estimate.file) {
        estimateFilesList.push({
          uid: estimate.id,
          name: estimate?.file?.name,
          status: APP_STATUS_DONE,
          url: `${API_URL}${estimate?.file?.url}`,
        })
      }
      setFileList(sortBy(estimateFilesList, ['uid']))
    }
  }, [selectedEstimate, isEstimateFetching, estimate])

  const onEstimateDownload = useCallback(
    (id) => (e) => {
      setSelectedEstimate(id)
      dispatch(getEstimateByIdAction({ id }))
      setShowFileList(true)
    },
    [dispatch]
  )

  const onEstimateAdd = useCallback(
    (id) => (e) => {
      setSelectedProject(id)
      setShowEstimateModal(true)
    },
    []
  )

  const columns = [
    {
      title: '№',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Название',
      dataIndex: ['attributes', 'name'],
      key: 'name',
    },
    {
      title: 'Описание',
      dataIndex: ['attributes', 'description'],
      key: 'description',
    },
    {
      title: 'Смета',
      dataIndex: ['attributes', 'estimate'],
      key: 'estimate',
      render: (estimate, record) => {
        const estimateId = estimate?.data?.id
        if (!estimateId) {
          return <Button onClick={onEstimateAdd(record?.id)}>Загрузить смету</Button>
        }

        return <Button onClick={onEstimateDownload(estimateId)}>Просмотреть смету</Button>
      },
    },
    {
      title: 'Действия',
      dataIndex: ['attributes', 'estimate'],
      key: 'actions',
      render: (estimate, record) => {
        const estimateId = estimate?.data?.id
        if (estimateId) {
          return <Button onClick={() => onEstimateClick(record.id, estimateId)}>Редактировать смету</Button>
        }
      },
    },
  ]
  return (
    <Spin spinning={isFetching || isEstimateFetching}>
      <Table pagination={tablePagination} style={{ paddingTop: 20 }} columns={columns} dataSource={projects} bordered />
      <AddEstimateModal
        projectId={selectedProject}
        showModal={showEstimateModal}
        isFetching={isFetching || isEstimateFetching}
        onChancel={() => setShowEstimateModal(false)}
        onFinish={() => dispatch(getProjectsAction({ pagination: { page, pageSize: 10 } }))}
      />
      <Modal
        title="Документы"
        visible={showFileList}
        onCancel={() => setShowFileList(false)}
        footer={[
          <Button key="back" onClick={() => setShowFileList(false)}>
            Закрыть
          </Button>,
        ]}
      >
        <Spin spinning={isFetching || isEstimateFetching}>
          <Upload
            fileList={fileList}
            disabled
            showUploadList={{
              showRemoveIcon: false,
            }}
          />
        </Spin>
      </Modal>
    </Spin>
  )
}

export default ProjectsTable
